export default "__VITE_ASSET__CgpGZSGy__"